import { Box, styled } from "@mui/material";

export const StyledLogin = styled(Box)(({ theme }) => ({
  height: "100vh",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  ".backgroundWrapper": {
    width: "100%",
    height: "100%",
    position: "absolute",
    background: theme.color.main,
    zIndex: "-1",
    img: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.mobile}px)`]: {
    justifyContent: "center",
  },
}));
